export default __webpack_public_path__ + "static/ak-cached/24h/media/smartcart_hero_image.5b6e0ad7.jpg";